import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, LinkedinIcon, InstagramIcon, PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-secondary text-white pt-16 pb-8" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12" data-id="element-22">
          {/* Company Info */}
          <div data-id="element-23">
            <div className="mb-6 bg-white inline-block p-4 rounded-lg" data-id="element-24">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ibuVzkycDnA7HHUx1J6KA1/magnavera-logo.jpg" alt="Magnavera Group" className="h-10" data-id="element-25" />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed font-open-sans" data-id="element-26">
              Empowering individuals and families with trusted guidance,
              lifelong education, and innovative wealth solutions.
            </p>
            <div className="flex space-x-4" data-id="element-27">
              <a href="#" aria-label="Facebook" className="bg-gray-800 p-2.5 rounded-full hover:bg-primary transition-colors duration-300" data-id="element-28">
                <FacebookIcon size={18} data-id="element-29" />
              </a>
              <a href="#" aria-label="Twitter" className="bg-gray-800 p-2.5 rounded-full hover:bg-primary transition-colors duration-300" data-id="element-30">
                <TwitterIcon size={18} data-id="element-31" />
              </a>
              <a href="#" aria-label="LinkedIn" className="bg-gray-800 p-2.5 rounded-full hover:bg-primary transition-colors duration-300" data-id="element-32">
                <LinkedinIcon size={18} data-id="element-33" />
              </a>
              <a href="#" aria-label="Instagram" className="bg-gray-800 p-2.5 rounded-full hover:bg-primary transition-colors duration-300" data-id="element-34">
                <InstagramIcon size={18} data-id="element-35" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-36">
            <h4 className="font-raleway font-semibold text-lg mb-6 relative" data-id="element-37">
              <span className="relative z-10" data-id="element-38">Quick Links</span>
              <span className="absolute left-0 bottom-0 w-12 h-0.5 bg-primary" data-id="element-39"></span>
            </h4>
            <ul className="space-y-3 font-open-sans" data-id="element-40">
              <li data-id="element-41">
                <Link to="/" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-42">
                  Home
                </Link>
              </li>
              <li data-id="element-43">
                <Link to="/about" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-44">
                  About Us
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/services" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-46">
                  Services
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/careers" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-48">
                  Careers
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/faq" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-50">
                  FAQ
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/contact" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-52">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          {/* Services */}
          <div data-id="element-53">
            <h4 className="font-raleway font-semibold text-lg mb-6 relative" data-id="element-54">
              <span className="relative z-10" data-id="element-55">Our Services</span>
              <span className="absolute left-0 bottom-0 w-12 h-0.5 bg-primary" data-id="element-56"></span>
            </h4>
            <ul className="space-y-3 font-open-sans" data-id="element-57">
              <li data-id="element-58">
                <Link to="/services" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-59">
                  Wealth & Investment Solutions
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/services" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-61">
                  Insurance & Protection
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/services" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-63">
                  Estate & Legacy Planning
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/services" className="text-gray-300 hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-65">
                  Corporate Solutions
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-66">
            <h4 className="font-raleway font-semibold text-lg mb-6 relative" data-id="element-67">
              <span className="relative z-10" data-id="element-68">Contact Us</span>
              <span className="absolute left-0 bottom-0 w-12 h-0.5 bg-primary" data-id="element-69"></span>
            </h4>
            <ul className="space-y-4 font-open-sans" data-id="element-70">
              <li className="flex items-start" data-id="element-71">
                <MapPinIcon className="text-primary mr-3 mt-1 flex-shrink-0" size={18} data-id="element-72" />
                <span className="text-gray-300" data-id="element-73">
                  3 Pickering St, #02-08
                  <br data-id="element-74" />
                  Singapore 048660, Singapore
                </span>
              </li>
              <li className="flex items-center" data-id="element-75">
                <PhoneIcon className="text-primary mr-3 flex-shrink-0" size={18} data-id="element-76" />
                <a href="tel:+6589701506" className="text-gray-300 hover:text-primary transition-colors duration-200" data-id="element-77">
                  +65 8970 1506
                </a>
              </li>
              <li className="flex items-center" data-id="element-78">
                <MailIcon className="text-primary mr-3 flex-shrink-0" size={18} data-id="element-79" />
                <a href="mailto:vjayvarmmanadmin@rep.greateasternfa.sg" className="text-gray-300 hover:text-primary transition-colors duration-200" data-id="element-80">
                  vjayvarmmanadmin@rep.greateasternfa.sg
                </a>
              </li>
              <li className="flex items-start" data-id="element-81">
                <ClockIcon className="text-primary mr-3 mt-1 flex-shrink-0" size={18} data-id="element-82" />
                <span className="text-gray-300" data-id="element-83">
                  Mon-Fri: By appointment only
                  <br data-id="element-84" />
                  Closed on Sat and Sun
                </span>
              </li>
            </ul>
          </div>
        </div>
        {/* Disclaimer */}
        <div className="pt-8 border-t border-gray-800 mb-8" data-id="element-85">
          <p className="text-xs text-gray-400 leading-relaxed font-open-sans" data-id="element-86">
            The views and opinions expressed in this website are solely that of
            the author and do not necessarily reflect the opinion of Great
            Eastern Financial Advisers Private Limited (GEFA). For the avoidance
            of doubt, GEFA does not make any representations or warranties,
            express or implied, as to the completeness or accuracy of the
            information contained in this website. Further, GEFA expressly
            disclaims any and all liability relating to or arising from the use
            of and/or reliance on the information contained in this website. The
            information contained in this website is for your information only
            and does not have regard to the specific investment objectives,
            financial situation and particular needs of any person(s).
          </p>
        </div>
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800" data-id="element-87">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-88">
            <p className="text-sm text-gray-400 mb-4 md:mb-0 font-open-sans" data-id="element-89">
              © {currentYear} Magnavera Group. All rights reserved.
            </p>
            <p className="text-xs text-gray-500 font-open-sans" data-id="element-90">
              Magnavera Group is a group of representatives of Great Eastern
              Financial Advisers Pte Ltd (GEFA).
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;